import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import DevicesList from '../Devices/Table.vue';
import Sidebar from 'primevue/sidebar';
import AddDevice from '../Devices/EditCreate.vue';
import SoildataList from '../SoilData/Table.vue';
import SymptomsList from '../SymptomRecords/Table.vue';
import FertilizationsList from './Fertilizations/Table.vue';
import LeavesDataList from '../LeavesData/Table.vue';
import IrrigationsList from './Irrigations/List.vue';
import { defineAsyncComponent, ref } from 'vue';
import { useMitt } from '@/Plugins/mitt';
import { FormPanel } from '@/@types/Enums';
import { formatISODate } from '@/Services/Utils';
import PlotService from '@/Services/PlotService';
import DetailRecordsList from './DetailRecordsList.vue';
import { trans } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        plot: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const PlotForm = defineAsyncComponent(() => import('./EditCreate.vue'));
        const emitter = useMitt();
        const plotService = new PlotService();
        const localPlot = ref(props.plot);
        emitter.off('plot-saved');
        emitter.on('plot-saved', (data) => {
            localPlot.value = data;
            Object.assign(props.plot, localPlot.value);
        });
        const visibleRightDevicesList = ref(false);
        const visibleRightAddDevice = ref(false);
        const soilDataListVisible = ref(false);
        const visibleRightSymptomsList = ref(false);
        const visibleRightLeavesList = ref(false);
        const visibleRightFertilizationsList = ref(false);
        const irrigationsListVisible = ref(false);
        const reloadPlot = () => {
            plotService.getById(props.plot.id).then((plot) => {
                localPlot.value = plot;
                Object.assign(props.plot, localPlot.value);
            });
        };
        const savedEvents = [
            'irrigation-saved',
            'fertilization-saved',
            'leaves-data-saved',
            'soil-data-saved',
            'symptom-record-saved',
        ];
        savedEvents.forEach((event) => {
            emitter.off(event);
            emitter.on(event, () => reloadPlot());
        });
        const edit = () => emitter.emit('open-form-panel', {
            label: trans('panels.PlotForm.edit_title') + ': ' + localPlot.value.code,
            component: PlotForm,
            data: localPlot.value,
        });
        const listPanelTitle = (baseTitle) => `${baseTitle}: ${localPlot.value.orchard.name} - ${localPlot.value.code}`;
        const addFertilization = () => emitter.emit('open-fertilization-form', {
            orchard: { id: localPlot.value.orchard_id },
            plots: [localPlot.value],
        });
        const openFertilizationDetails = (data) => emitter.emit('open-fertilization-details', data);
        const openIrrigationDetails = (data) => emitter.emit('open-irrigation-details', data);
        const addIrrigation = () => emitter.emit('open-form-panel-enum', {
            form: FormPanel.Irrigation,
            data: {
                orchard_id: localPlot.value.orchard_id,
                plot_ids: [localPlot.value.id],
            },
        });
        const addLeavesData = () => emitter.emit('open-leaves-data-form', {
            orchard: { id: localPlot.value.orchard_id },
            plots: [localPlot.value],
        });
        const openLeavesDataDetails = (data) => emitter.emit('open-leaves-data-details', data);
        const addSoilData = () => emitter.emit('open-soil-data-form', {
            orchard: { id: localPlot.value.orchard_id },
            plots: [localPlot.value],
        });
        const openSoilDataDetails = (data) => emitter.emit('open-soil-data-details', data);
        const addSymptomRecord = () => emitter.emit('open-symptom-record-form', {
            orchard: { id: localPlot.value.orchard_id },
            plots: [localPlot.value],
        });
        const openSymptomRecordDetails = (data) => emitter.emit('open-symptom-record-details', data);
        const __returned__ = { PlotForm, props, emitter, plotService, localPlot, visibleRightDevicesList, visibleRightAddDevice, soilDataListVisible, visibleRightSymptomsList, visibleRightLeavesList, visibleRightFertilizationsList, irrigationsListVisible, reloadPlot, savedEvents, edit, listPanelTitle, addFertilization, openFertilizationDetails, openIrrigationDetails, addIrrigation, addLeavesData, openLeavesDataDetails, addSoilData, openSoilDataDetails, addSymptomRecord, openSymptomRecordDetails, get Button() { return Button; }, DevicesList, get Sidebar() { return Sidebar; }, AddDevice, SoildataList, SymptomsList, FertilizationsList, LeavesDataList, IrrigationsList, get formatISODate() { return formatISODate; }, DetailRecordsList, get trans() { return trans; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
